module.exports = __webpack_public_path__ + "static/media/1C.564c4b8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/ReportWidget/images/1C.svg
// module id = 658
// module chunks = 0